// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"e92b1874","70":"d9d83f52","79":"f54e3dda","198":"5efe4463","213":"5b79721a","453":"11dce4a7","455":"37dd1e5f","573":"4eb46419"}[chunkId] + ".chunk.js";
};